(function(angular) {
    'use strict';

    /**
     * @ngdoc service
     * @name WtNotificationAlert
     * @description Notification that requires a user interaction like providing an input or selecting Yes|No, OK|Cancel, Apply|Discard etc.
     * This is a placeholder for future implementation
     */
    angular.module('wtApp.dataService').factory('WtNotificationAlert', function() {
        return WtNotificationAlert;
    });

    function WtNotificationAlert(iMessage) {
        this.message = String(iMessage);
    }
})(window.angular);
